import React from 'react'
import Radio from './radio'
import './index.less'

export default ({ children, className, ...otherProps }) => {
  return <Radio
    prefixClass="mn"
    className={className}
    {...otherProps}
  >{children}
  </Radio>
}
